import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from 'moment';
let TimeRangesSelect = class TimeRangesSelect extends Vue {
    constructor() {
        super(...arguments);
        this.options = [{
                value: 1,
                label: '当天'
            }, {
                value: 2,
                label: '昨天'
            }, {
                value: 3,
                label: '本周'
            }, {
                value: 4,
                label: '上周'
            }, {
                value: 5,
                label: '本月'
            }, {
                value: 6,
                label: '上月'
            }, {
                value: 7,
                label: '本季度'
            }, {
                value: 8,
                label: '本年度'
            }];
        this.curIndex = '';
        this.val = '';
    }
    get optionsList() {
        switch (Number(this.displayFormat)) {
            case 4:
                return this.options.filter((o) => o.value > 4);
            case 5:
                return this.options.filter((o) => o.value == 8);
            default:
                return this.options;
        }
    }
    created() {
        this.setMomentLocale(this.$i18n.locale);
    }
    //语言为中文时自然周从周一开始。
    setMomentLocale(lang) {
        if (lang === 'en') {
            moment.locale('en-US');
        }
        else {
            moment.locale('zh-cn');
        }
    }
    // 日期控件国际化
    onLanguageChange(val) {
        this.setMomentLocale(val);
    }
    onClick(item, index) {
        this.curIndex = index;
        this.val = {};
        switch (item.value) {
            case 1:
                this.val.start = moment().startOf('days');
                this.val.end = moment().endOf('days');
                break;
            case 2:
                this.val.start = moment().add(-1, 'days').startOf('days');
                this.val.end = moment().add(-1, 'days').endOf('days');
                break;
            case 3:
                this.val.start = moment().startOf('week');
                this.val.end = moment().endOf('week');
                break;
            case 4:
                this.val.start = moment().week(moment().week() - 1).startOf('week');
                this.val.end = moment().week(moment().week() - 1).endOf('week');
                break;
            case 5:
                this.val.start = moment().startOf('month');
                this.val.end = moment().endOf('month');
                break;
            case 6:
                this.val.start = moment().month(moment().month() - 1).startOf('month');
                this.val.end = moment().month(moment().month() - 1).endOf('month');
                break;
            case 7:
                this.val.start = moment().startOf('quarter');
                this.val.end = moment().endOf('quarter');
                break;
            case 8:
                this.val.start = moment().startOf('year');
                this.val.end = moment().endOf('year');
                break;
        }
        this.$emit('onChange', this.val);
    }
    clear() {
        this.curIndex = '';
    }
};
tslib_1.__decorate([
    Prop({
        default: '1'
    })
], TimeRangesSelect.prototype, "displayFormat", void 0);
tslib_1.__decorate([
    Watch('$i18n.locale')
], TimeRangesSelect.prototype, "onLanguageChange", null);
TimeRangesSelect = tslib_1.__decorate([
    Component({
        name: "time-ranges-select",
        components: {}
    })
], TimeRangesSelect);
export default TimeRangesSelect;
